import React, { useEffect, useRef } from "react";
import { Button, Modal, Form as BTForm } from "react-bootstrap";
import axios from "src/config/axios";
import { Form, Formik } from "formik";
import FormSelectBox from "src/components/Forms/FormSelectBox";
import FormPriceInput from "src/components/Forms/FormPriceInput";
import { useState } from "react";
import FormInputText from "src/components/Forms/FormInputText";

const EditExtraPriceDialog = ({
  show,
  toggle,
  extraPrice = {},
  handleSuccess = null,
}) => {
  function validate(values) {
    const errors = {}; // if (!values.nfc_card_uid) {
    //   errors.nfc_card_uid = "NFC Nummer ist ein Pflichtfeld";
    // }

    return errors;
  }

  function submit(values, { setSubmitting, setErrors }) {
    setSubmitting(true);

    if (values.type_of === "local_tax") {
      values.season_id = "";
    } else {
      values.valid_from = "";
    }

    let request;

    if (extraPrice.id) {
      request = axios.put(`/api/v1/extra_prices/${extraPrice.id}.json`, {
        extra_price: values,
      });
    } else {
      request = axios.post(`/api/v1/extra_prices.json`, {
        extra_price: values,
      });
    }

    request
      .then(function () {
        toggle();
        handleSuccess();
      })
      .catch(function (e) {
        setErrors(e.response.data);
      });
  }

  const [template, setTemplate] = useState();
  const formRef = useRef();

  useEffect(() => {
    fetchTemplate();
  }, []);

  const fetchTemplate = () => {
    axios
      .get(`/api/v1/extra_prices/template.json`)
      .then(function (response) {
        setTemplate(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleSubmit = () => {
    formRef.current.handleSubmit();
  };

  return (
    <Modal show={show} onHide={toggle}>
      <Modal.Header>
        <Modal.Title>{!extraPrice.id ? "Erstellen" : "Bearbeiten"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={{
            type_of: extraPrice.type_of ?? "",
            season_id: extraPrice.season_id ?? template?.season_id ?? "",
            valid_from: extraPrice.valid_from ?? template?.valid_from,
            price_per: extraPrice.price_per ?? "",
            price: extraPrice.price ?? template?.price ?? "",
          }}
          validate={validate}
          onSubmit={submit}
        >
          {({ values }) => (
            <Form autoComplete="false">
              <FormSelectBox
                name="type_of"
                label="Name"
                options={template.settings.type_ofs}
                option_name="name"
                option_value="value"
                required
              />

              {values.type_of === "local_tax" && (
                <FormInputText
                  name="valid_from"
                  label="Gültig ab"
                  type="date"
                  required
                />
              )}

              {values.type_of !== "local_tax" && (
                <FormSelectBox
                  name="season_id"
                  label="Saison"
                  options={template.settings.seasons}
                  option_name="name"
                  option_value="id"
                  required
                />
              )}

              <FormPriceInput
                name="price"
                label="Preis"
                placeholder="0.00"
                required
              />
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          Schließen
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditExtraPriceDialog;
